import type { EffectivePermissions } from '@ic/platform-contract';
import { accessRulesFromWire, type AccessRules } from '@ic/security-registry';

/**
 * The rule sets `GET /api/auth/effective-permissions` returns for the shared evaluator (design.md C2).
 * Every field beyond the original response is optional on the wire for one release: an SPA deployed
 * ahead of the backend sees none of them.
 */
export interface EffectivePermissionsWire extends EffectivePermissions {
  denials?: string[];
  everyoneAllows?: string[];
  everyoneDenials?: string[];
  inactivatedPaths?: string[];
  reactivatedPaths?: string[];
}

export type { AccessRules } from '@ic/security-registry';

/**
 * Maps the wire response to the registry evaluator's input; no session grants nothing. A response
 * with none of the rule sets never reaches the evaluator: `canAccess` matches exactly instead.
 */
export function toAccessRules(effective: EffectivePermissionsWire | null): AccessRules {
  return accessRulesFromWire(effective ?? {});
}
